import * as sdk from './importShareSDK'

export function wx (fn) {
  sdk.wx(fn)
}

export function alipay (fn) {
  sdk.alipay(fn)
}

export function alipayMp (fn) {
  sdk.alipayMp(fn)
}
